import { DisconnectVertex } from "./types";

/**
 * Removes the connection to a specific neighbor from a vertex.
 * Note: This only removes the edge one way (from -> neighbor).
 * To fully disconnect, call this for both vertices.
 */
export const disconnectVertex: DisconnectVertex = ({
  graph,
  fromNode,
  neighborToRemove,
}) => {
  if (!graph[fromNode]) return;

  graph[fromNode] = graph[fromNode].filter(
    ([neighborId]) => neighborId !== neighborToRemove,
  );
};
